import React from "react";
import Icon from "@ant-design/icons";

const UploadSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    stroke="currentColor"
  >
    <path stroke="#344054" strokeLinecap="round" d="M8 10.8V3.2"></path>
    <path
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.6 5.2l2.4-2 2.4 2M3.2 9.6v3.2h9.6V9.6"
    ></path>
  </svg>
);

const UploadIcon = (props) => <Icon component={UploadSvg} {...props} />;

export { UploadIcon };
